import { render, staticRenderFns } from "./GTNewsPortalIndex.vue?vue&type=template&id=656822fd&scoped=true"
import script from "./GTNewsPortalIndex.vue?vue&type=script&lang=js"
export * from "./GTNewsPortalIndex.vue?vue&type=script&lang=js"
import style0 from "./GTNewsPortalIndex.vue?vue&type=style&index=0&id=656822fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656822fd",
  null
  
)

export default component.exports